import { render } from "./push-courses.vue?vue&type=template&id=33222777&scoped=true"
import script from "./push-courses.vue?vue&type=script&lang=ts"
export * from "./push-courses.vue?vue&type=script&lang=ts"

import "./push-courses.vue?vue&type=style&index=0&id=33222777&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33222777"

export default script